import {
  FETCH_UNIT_REQUEST, FETCH_UNIT_RESPONSE,
  SAVE_UNIT_RESPONSE,
  LIST_UNITS_RESPONSE,
  LIST_COMMUNITY_UNITS_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// unitId -> {unit}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case FETCH_UNIT_REQUEST:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          isLoading: true,
        },
      }

    case SAVE_UNIT_RESPONSE:
    case FETCH_UNIT_RESPONSE:
      return {
        ...state,
        [action.unit.id]: {
          ...action.unit,
          isLoading: false,
        },
      }

    case LIST_UNITS_RESPONSE:
    case LIST_COMMUNITY_UNITS_RESPONSE: {
      const s = { ...state }
      const units = action.units || []
      units.forEach((u) => {
        s[u.id] = {
          ...u,
          isLoading: false,
        }
      })
      return s
    }

    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
